
export default function(o,duration,shuffle){
  
  var s = o.sounds.main
  
  if(shuffle){
    s.sound.currentTime = _.random(s.sound.duration)
  }
  
  console.log('play sound')

  s.sound.play()

  s.sound.volume = 0

  $(s.sound)
  .stop()
  .animate(
    {volume: s.volume},
    duration,
    function(){
      console.log('play sound completed')
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/soundPlay/soundPlay.js